import {Component, OnInit, ViewChild} from '@angular/core';
import {DropdownService} from "../../../services/dropdown.service";
import {AgencyCountyCityList, AgencyORIList, CountyCityList} from "../../../NIBINInterface";
import {
  BeforeBatchSaveArgs,
  EditSettingsModel,
  GridComponent,
  IEditCell,
  ToolbarItems
} from "@syncfusion/ej2-angular-grids";
import { Query, DataManager } from '@syncfusion/ej2-data';
import {L10n} from "@syncfusion/ej2-base";

L10n.load({
  'en_US': {
    grid: {
      Update: 'Save',
    }
  }
});

@Component({
  selector: 'app-settins-places',
  templateUrl: './settins-places.component.html',
  styleUrls: ['./settins-places.component.css'],
  providers:[DropdownService]
})
export class SettinsPlacesComponent implements OnInit {

  states:any = []
  SelectedState:string = "NJ"
  counties: CountyCityList[] = []
  cities: CountyCityList[] = []
  AgencyList: AgencyORIList[] = []

  @ViewChild('CitiesGrid') public CitiesGrid!: GridComponent;
  @ViewChild('AgencyGrid') public AgencyGrid!: GridComponent;
  public editSettings!: EditSettingsModel;
  public toolbar!: ToolbarItems[];

  constructor(private dropdownService: DropdownService) { }

  ngOnInit(): void {
    this.loadDDLS()

    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Batch' };
    this.toolbar = ['Add', 'Delete', 'Update', 'Cancel'];
  }

  loadSyncEditList(){
    if((this.CitiesGrid.getColumnByField('County').edit.params as any)!=null){
      (this.CitiesGrid.getColumnByField('County').edit.params as any).dataSource = new DataManager(this.counties);
      (this.AgencyGrid.getColumnByField('County').edit.params as any).dataSource = new DataManager(this.counties);
    }
  }

  async loadDDLS():Promise<void>{
    this.states = await this.dropdownService.getStates()
    this.counties = await this.dropdownService.getCountyForState(this.SelectedState)
    this.cities = await this.dropdownService.getCityForCountyAndState("",this.SelectedState)
    this.AgencyList = await this.dropdownService.getAgencyForCountyAndState("",this.SelectedState)
    this.loadSyncEditList();
  }

  getCountyArray():string[]{
    let t:string[] = [];
    for(let o of this.counties)
      if(o.County)
       t.push(o.County)


    return t
  }

  UpdateSelectedState() {
    this.loadDDLS()
  }

  CountyBatchSave($event: any) {
    for(let r of $event.batchChanges.addedRecords){
      let req:AgencyCountyCityList = {
        County:r.County,
        State:this.SelectedState
      }
      this.dropdownService.addCountyForState(req).then(r=>{this.loadDDLS()})
    }

    for(let r of $event.batchChanges.changedRecords){
      let req:AgencyCountyCityList = {
        County:r.County,
        State:this.SelectedState,
        ID:r.ID
      }
      this.dropdownService.updateCountyForState(req).then(r=>{this.loadDDLS()})
    }

    for(let r of $event.batchChanges.deletedRecords){
      let req:AgencyCountyCityList = {
        County:r.County,
        State:this.SelectedState,
        ID:r.ID
      }
      this.dropdownService.deleteCountyForState(req).then(r=>{this.loadDDLS()})
    }
  }

  AgencyBatchSave($event: any) {
    for(let r of $event.batchChanges.addedRecords){
      let req:AgencyCountyCityList = {
        Agency:r.DeptName,
        ORI:r.DeptORI,
        County:r.County,
        City:r.City,
        State:this.SelectedState
      }
      this.dropdownService.addAgencyForCountyState(req).then(r=>{this.loadDDLS()})
    }

    for(let r of $event.batchChanges.changedRecords){
      let req:AgencyCountyCityList = {
        Agency:r.DeptName,
        ORI:r.DeptORI,
        County:r.County,
        City:r.City,
        State:this.SelectedState,
        ID:r.ID
      }
      this.dropdownService.updateAgencyForCountyState(req).then(r=>{this.loadDDLS()})
    }

    for(let r of $event.batchChanges.deletedRecords){
      let req:AgencyCountyCityList = {
        Agency:r.DeptName,
        ORI:r.DeptORI,
        County:r.County,
        City:r.City,
        State:this.SelectedState,
        ID:r.ID
      }
      this.dropdownService.deleteAgencyForCountyState(req).then(r=>{this.loadDDLS()})
    }
  }

  CitiesBatchSave($event: any) {
    for(let r of $event.batchChanges.addedRecords){
      let req:AgencyCountyCityList = {
        County:r.County,
        City:r.City,
        State:this.SelectedState
      }
      this.dropdownService.addCityForCountyState(req).then(r=>{this.loadDDLS()})
    }

    for(let r of $event.batchChanges.changedRecords){
      let req:AgencyCountyCityList = {
        County:r.County,
        City:r.City,
        State:this.SelectedState,
        ID:r.ID
      }
      this.dropdownService.updateCityForCountyState(req).then(r=>{this.loadDDLS()})
    }

    for(let r of $event.batchChanges.deletedRecords){
      let req:AgencyCountyCityList = {
        County:r.County,
        City:r.City,
        State:this.SelectedState,
        ID:r.ID
      }
      this.dropdownService.deleteCityForCountyState(req).then(r=>{this.loadDDLS()})
    }
  }

}
